import { SHOPPING_LISTS_ENDPOINTS } from "./endpoints";
import type { SendShoppingListEmailResponse, SupermarketCode } from "./types";
import { apiPostWithData } from "../shared";

function buildSendCurrentListEmailUrl(weekStart?: string, supermarketCode?: SupermarketCode): string {
  const params = new URLSearchParams();
  if (weekStart) params.append("week_start", weekStart);
  if (supermarketCode) params.append("supermarket_code", supermarketCode);
  return params.toString()
    ? `${SHOPPING_LISTS_ENDPOINTS.SEND_CURRENT_EMAIL}?${params.toString()}`
    : SHOPPING_LISTS_ENDPOINTS.SEND_CURRENT_EMAIL;
}

export async function sendCurrentShoppingListEmail(
  weekStart?: string,
  supermarketCode?: SupermarketCode
): Promise<SendShoppingListEmailResponse> {
  const url = buildSendCurrentListEmailUrl(weekStart, supermarketCode);
  return apiPostWithData<SendShoppingListEmailResponse>(url);
}

export default sendCurrentShoppingListEmail;
